import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  duration: string; // e.g. "1 day ago", "1 month ago", "1 year ago"
  size?: 'xsmall' | 'small' | 'standard' | 'large';
}

export const LastUpdated = ({ duration, size = 'small' }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Text size={size} tone="secondary">
      {t('UPDATED_DATE', {
        lastModifiedDuration: duration,
      })}
    </Text>
  );
};
